import type { ReactNode } from 'react';

export interface PageHeaderProps {
  title: string;
  subtitle?: ReactNode;
  actions?: ReactNode;
}

/**
 * 768px 未満ではタイトルと操作を縦に積む。同じ行に並べたままだと、
 * 見出しが 1 文字ずつ折り返して読めなくなる (月送りと CSV 出力が幅を要求するため)。
 *
 * 768px 以上の描画は変えない。`md:` 側で横並び・余白・`gap-0` まで書き戻してある
 * (`gap` を無印のまま残すと、タイトルが長いときだけ 768px 以上の間隔が変わる)。
 */
export function PageHeader({ title, subtitle, actions }: PageHeaderProps) {
  return (
    <div className="flex flex-col gap-3 border-b border-line bg-surface-raised px-4 py-4 md:flex-row md:items-center md:justify-between md:gap-0 md:px-8 md:py-5">
      <div className="flex flex-col gap-1">
        <h1 className="text-xl font-bold tracking-tight">{title}</h1>
        {subtitle ? <span className="text-xs text-ink-subtle">{subtitle}</span> : null}
      </div>
      {actions ? (
        <div className="flex flex-wrap items-center gap-2.5 md:flex-nowrap">{actions}</div>
      ) : null}
    </div>
  );
}
